// extracted by mini-css-extract-plugin
export default {"footer":"FilterSelectAllExtraFooter_footer__rWwDX"};